import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import FooterButtonView from "./FooterButtonView";
import StepWizard from "./StepWizard";
import StepSelectTestTube from "./StepSelectTestTube";
import StepSelectBiomarkers from "./StepSelectBiomarkers";
import StepReview from "./StepReview";

export default function CreateModal({
  isOpen,
  handleClose,
  step,
  selectedType,
  setSelectedType,
  selectedBiomarkers,
  setSelectedBiomarkers,
  isSubmitting,
  handleBack,
  handleNext,
  result
}) {
  return (
    <Modal isOpen={isOpen} toggle={() => handleClose(null)} centered size="lg">
      <ModalHeader toggle={() => handleClose(null)}>
        Create Retest Order
        <br />
        Follow the steps to create a targeted biomarker retest
      </ModalHeader>
      <ModalBody>
        <section style={{ width: "100%" }}>
          <StepWizard step={step} />
          <div style={{ height: 355, overflowY: "auto", overflowX: "hidden" }}>
            {step === 1 && (
              <StepSelectTestTube selectedType={selectedType} setSelectedType={setSelectedType} />
            )}
            {step === 2 && (
              <StepSelectBiomarkers
                selectedType={selectedType}
                kitObjectId={result.id}
                selectedBiomarkers={selectedBiomarkers}
                setSelectedBiomarkers={setSelectedBiomarkers}
                UserSex={result.sex}
              />
            )}
            {step === 3 && (
              <StepReview selectedBiomarkers={selectedBiomarkers} selectedType={selectedType} />
            )}
          </div>
        </section>
      </ModalBody>
      <ModalFooter>
        <FooterButtonView
          step={step}
          isSubmitting={isSubmitting}
          selectedBiomarkers={selectedBiomarkers}
          onClose={handleClose}
          onBack={handleBack}
          onNext={handleNext}
        />
      </ModalFooter>
    </Modal>
  );
}
